module.exports = __webpack_public_path__ + "media/application/images/icons/icon-location-2-8ad0065be0e0b7adc49a862495ac7375.svg";